import { Events } from './events'
import { QuickStorage } from './quickStorage'
import enTexts from './raws/translates/en.json'
import frTexts from './raws/translates/fr.json'

class Translate {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    Translate.storeLangToUse()
  }
  static getOptions() {
    return [
      {
        id: 'fr',
        name: 'Français',
      },
      {
        id: 'en',
        name: 'Anglais',
      },
    ]
  }
  static changeLang(newLang) {
    if (newLang !== 'fr' && newLang !== 'en') return
    QuickStorage.storeData('language', newLang)
    Translate.storeLangToUse()
    Events.dispatchEvent('lang_changed')
  }
  static getLang() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return 'fr'
    if (!window.lang) Translate.storeLangToUse()
    return window.lang
  }
  static storeLangToUse() {
    const savedLanguage = QuickStorage.getStored('language')
    window.lang = savedLanguage || Translate.getBrowserLanguage()
  }
  static getBrowserLanguage() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return 'fr'
    const userLang = navigator.language || navigator.userLanguage
    if (userLang.startsWith('en')) {
      return 'fr' || 'en'
    }
    return 'fr'
  }
  static getLanguageTexts() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return frTexts
    const currentLang = Translate.getLang()
    if (currentLang == 'fr') return frTexts
    if (currentLang == 'en') return enTexts
  }
  static $t(text, replacement = {}, splitString = '.') {
    const splitedPath = text.split(splitString)
    let value = Translate.getLanguageTexts()
    splitedPath.forEach(path => {
      if (!value) return
      value = value[path]
    })
    if (!/(boolean)|(number)|(string)/.test(typeof value)) {
      return '' + text.split(splitString).pop()
    }
    const replacementToUse = replacement || {}
    Object.keys(replacementToUse).forEach(key => {
      const regex = new RegExp('\\$\\{' + key + '\\}', 'g')
      value = value.replace(regex, replacementToUse[key])
    })
    return value
  }
}

export { Translate }
